<script lang="ts" setup>
    import { ref, nextTick, computed, reactive } from "vue";
    import { ITimelineMedication, ITimelineSectionClick, TimelineSection } from "../lib/Models/EMR/TimelineModel";
    import { NoTzDate } from '../lib/DateUtils';

    defineExpose({buildDisplay});
    const emit = defineEmits<{
        (e: "displayBuiltSection", strValue: ITimelineSectionClick): void
    }>(); 

    const formData = reactive<{
        prescribedList: ITimelineMedication[],
        stoppedList: ITimelineMedication[],
        patientReportedList: ITimelineMedication[]
    }>({
        prescribedList: [],
        stoppedList: [],
        patientReportedList: []
    });

    const prescribedItems = computed<boolean>(() => (formData?.prescribedList.length > 0 ? true : false));
    const stoppedItems = computed<boolean>(() => (formData?.stoppedList.length > 0 ? true : false));
    const patientReportedItems = computed<boolean>(() => (formData?.patientReportedList.length > 0 ? true : false));

    function patientReported(item: ITimelineMedication) {
        return item.patientReported;
    }

    function buildDisplay(medicationList: ITimelineMedication[], date: NoTzDate) {
        formData.prescribedList = medicationList.filter(item => item.startDate === date && !item.patientReported);
        formData.stoppedList= medicationList.filter(item => item.stopDate === date && !item.patientReported);
        formData.patientReportedList = medicationList.filter(item => (item.startDate === date || item.stopDate === date) && item.patientReported);

        nextTick(() => { 
            const element = document.getElementById("medicationDisplayHtml");
            if (!element)
                return;
            const timelineSectionClick: ITimelineSectionClick =  {
                id: TimelineSection.Medications,
                date: date,
                html: element.outerHTML
            }
            emit("displayBuiltSection", timelineSectionClick);
        }); 
    }

</script>

<template>
    <div id="medicationDisplayHtml">
        <div v-if="prescribedItems"><span>Prescribed</span></div>
        <div v-for="item in formData.prescribedList"><span class="padding-indented"><b>{{item.drugName}}</b></span><br /><span class="padding-indented"><i>{{item.prescribedBy}}</i></span><br /></div>

        <div v-if="stoppedItems"><span>Stopped</span></div>
        <div v-for="item in formData.stoppedList"><span class="padding-indented"><b>{{item.drugName}}</b></span><br /><span class="padding-indented"><i>{{item.prescribedBy}}</i></span><br /></div>

        <div v-if="patientReportedItems"><span>Historical</span></div>
        <div v-for="item in formData.patientReportedList"><span class="padding-indented"><b>{{item.drugName}}</b></span><br /><span class="padding-indented"><i>{{item.prescribedBy}}</i></span><br /></div>
    </div>
</template>